export {
	SmdFabSpeedDialActionsComponent,
	SmdFabSpeedDialComponent,
	SmdFabSpeedDialTriggerComponent
} from "./fab.component";



// WEBPACK FOOTER //
// ./src/app/shared/components/fab/index.ts